export default __webpack_public_path__ + "static/media/eth-logo.a85b6de0.png";